module.exports = __webpack_public_path__ + "img/7a30107.jpg";